var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLinkSimpleHorizontalBreak = function SvgIconLinkSimpleHorizontalBreak(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.525 9.525A3.5 3.5 0 0 1 6 8.5h3.75a1 1 0 1 0 0-2H6a5.5 5.5 0 1 0 0 11h3.75a1 1 0 1 0 0-2H6a3.5 3.5 0 0 1-2.475-5.975M14.25 6.5a1 1 0 1 0 0 2H18a3.5 3.5 0 1 1 0 7h-3.75a1 1 0 1 0 0 2H18a5.5 5.5 0 0 0 0-11z"
  }))));
};
export default SvgIconLinkSimpleHorizontalBreak;